var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.512207,
    width: 42.544,
    height: 40.7463,
    rx: 2.99605,
    fill: "url(#paint0_linear_95_870)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.772 8.88538H13.772C10.8253 8.88538 8.43863 11.2587 8.43863 14.1787V27.592C8.43863 30.512 10.8253 32.8854 13.772 32.8854H29.772C32.7186 32.8854 35.1053 30.512 35.1053 27.592V14.1787C35.1053 11.2587 32.7186 8.88538 29.772 8.88538ZM17.1053 14.4454C18.7986 14.4454 20.1853 15.832 20.1853 17.5254C20.1853 19.2187 18.7986 20.6054 17.1053 20.6054C15.412 20.6054 14.0253 19.2187 14.0253 17.5254C14.0253 15.832 15.412 14.4454 17.1053 14.4454ZM22.2653 27.0987C22.1453 27.232 21.9586 27.312 21.772 27.312H12.4386C12.252 27.312 12.0653 27.232 11.9453 27.0987C11.8253 26.9654 11.7586 26.7787 11.772 26.592C11.9986 24.352 13.7853 22.5787 16.0253 22.3654C16.732 22.2987 17.4653 22.2987 18.172 22.3654C20.412 22.5787 22.212 24.352 22.4253 26.592C22.452 26.7787 22.3853 26.9654 22.2653 27.0987ZM31.1053 27.2187H28.4386C27.892 27.2187 27.4386 26.7654 27.4386 26.2187C27.4386 25.672 27.892 25.2187 28.4386 25.2187H31.1053C31.652 25.2187 32.1053 25.672 32.1053 26.2187C32.1053 26.7654 31.652 27.2187 31.1053 27.2187ZM31.1053 21.8854H25.772C25.2253 21.8854 24.772 21.432 24.772 20.8854C24.772 20.3387 25.2253 19.8854 25.772 19.8854H31.1053C31.652 19.8854 32.1053 20.3387 32.1053 20.8854C32.1053 21.432 31.652 21.8854 31.1053 21.8854ZM31.1053 16.552H24.4386C23.892 16.552 23.4386 16.0987 23.4386 15.552C23.4386 15.0054 23.892 14.552 24.4386 14.552H31.1053C31.652 14.552 32.1053 15.0054 32.1053 15.552C32.1053 16.0987 31.652 16.552 31.1053 16.552Z",
    fill: "#F3F3F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_870",
    x1: 21.772,
    y1: 0.512207,
    x2: 21.772,
    y2: 41.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF1435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#890B1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector5.6acfae1d6cbd91e4ba0932cee60cbe8a.svg";
export { ForwardRef as ReactComponent };